var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"SEARCH","name":"SEARCH","aria-label":"SEARCH","data-command":_vm.$t('searchButton')}},[_c('img',{attrs:{"src":"/images/icons/search.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('searchButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }